/* SUPRAFEEL · Home catálogo completo — client-side filters (port of HwfShop.tsx).
   Groups are built from each card's data-*: gama (collection title), formato (read from custom.presentacion),
   duración (custom.duracion). Counts show what each option would leave given the other groups' selection. */
(function () {
  var FORMATS = [
    [/c[aá]psula/i, 'Cápsulas'],
    [/comprimido/i, 'Comprimidos'],
    [/perla/i, 'Perlas'],
    [/sobre/i, 'Sobres'],
    [/vial/i, 'Viales'],
    [/\d+\s*g\b/i, 'Polvo']
  ];
  var VISIBLE = 4;
  var formatOf = function (s) {
    for (var i = 0; i < FORMATS.length; i++) if (FORMATS[i][0].test(s)) return FORMATS[i][1];
    return s ? 'Otros' : '';
  };

  function init(root) {
    if (root.dataset.sfwReady) return;
    root.dataset.sfwReady = '1';
    var cards = [].slice.call(root.querySelectorAll('.sfw-ht__card'));
    var items = cards.map(function (el) {
      return { el: el, gama: el.dataset.gama || '', formato: formatOf(el.dataset.pres || ''), dias: (el.dataset.dias || '').trim() };
    });
    var groupsEl = root.querySelector('[data-sfw-groups]');
    var countEl = root.querySelector('[data-sfw-count]');
    var emptyEl = root.querySelector('[data-sfw-empty]');
    var gridEl = root.querySelector('[data-sfw-grid]');
    var clears = [].slice.call(root.querySelectorAll('[data-sfw-clear]'));
    var toggle = root.querySelector('[data-sfw-toggle]');
    var side = root.querySelector('[data-sfw-side]');

    var uniq = function (key, sort) {
      var seen = [];
      items.forEach(function (i) { if (i[key] && seen.indexOf(i[key]) < 0) seen.push(i[key]); });
      return sort ? seen.sort(sort) : seen;
    };
    var GROUPS = [
      { key: 'gama', label: 'Gama', options: uniq('gama'), open: true },
      { key: 'formato', label: 'Formato', options: FORMATS.map(function (f) { return f[1]; }).concat(['Otros']).filter(function (n) { return items.some(function (i) { return i.formato === n; }); }), open: true },
      { key: 'dias', label: 'Duración del envase', options: uniq('dias', function (a, b) { return (parseInt(a, 10) || 999) - (parseInt(b, 10) || 999); }), open: false }
    ].filter(function (g) { return g.options.length > 1; });
    var sel = {};
    GROUPS.forEach(function (g) { sel[g.key] = []; });
    // gama page: start with the current gama ticked (the shopper can clear it to see everything)
    var pre = root.dataset.preselect;
    if (pre && sel.gama && GROUPS.some(function (g) { return g.key === 'gama' && g.options.indexOf(pre) >= 0; })) sel.gama.push(pre);

    var matches = function (i, skip) {
      return GROUPS.every(function (g) { return g.key === skip || !sel[g.key].length || sel[g.key].indexOf(i[g.key]) >= 0; });
    };

    var chev = '<svg viewBox="0 0 16 16" aria-hidden="true" class="sfw-ht__chev"><path d="M4 10l4-4 4 4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

    groupsEl.innerHTML = GROUPS.map(function (g, gi) {
      return '<div class="sfw-ht__group" data-key="' + g.key + '">' +
        '<button type="button" class="sfw-ht__group-head" aria-expanded="' + g.open + '">' + esc(g.label) + chev + '</button>' +
        '<div class="sfw-ht__group-body' + (g.open ? ' is-open' : '') + '"><div class="sfw-ht__group-inner">' +
        g.options.map(function (o, oi) {
          var id = 'sfw-ht-' + gi + '-' + oi;
          return '<label for="' + id + '" class="sfw-ht__opt' + (oi >= VISIBLE ? ' is-extra' : '') + '">' +
            '<input id="' + id + '" type="checkbox" value="' + esc(o) + '"><span class="sfw-ht__box" aria-hidden="true"></span>' +
            '<span class="sfw-ht__opt-label">' + esc(o) + '</span><span class="sfw-ht__opt-n"></span></label>';
        }).join('') +
        (g.options.length > VISIBLE ? '<button type="button" class="sfw-ht__more"><span aria-hidden="true">+</span> Ver más</button>' : '') +
        '</div></div></div>';
    }).join('');

    function render() {
      var shown = 0;
      items.forEach(function (i) {
        var on = matches(i);
        i.el.hidden = !on;
        if (on) {
          shown++;
          i.el.classList.remove('is-in');
          void i.el.offsetWidth; // restart the short entrance
          i.el.classList.add('is-in');
        }
      });
      countEl.textContent = shown + (shown === 1 ? ' referencia' : ' referencias');
      emptyEl.hidden = shown > 0;
      gridEl.hidden = shown === 0;
      var active = GROUPS.reduce(function (n, g) { return n + sel[g.key].length; }, 0);
      clears.forEach(function (b) {
        if (b.closest('.sfw-ht__filters-head')) {
          b.hidden = active === 0;
          b.textContent = 'Quitar filtros (' + active + ')';
        }
      });
      if (toggle) toggle.textContent = active ? 'Filtros (' + active + ')' : 'Filtros';
      GROUPS.forEach(function (g) {
        [].forEach.call(groupsEl.querySelectorAll('[data-key="' + g.key + '"] .sfw-ht__opt'), function (lab) {
          var input = lab.querySelector('input');
          var n = items.filter(function (i) { return i[g.key] === input.value && matches(i, g.key); }).length;
          lab.querySelector('.sfw-ht__opt-n').textContent = n;
          lab.classList.toggle('is-empty', n === 0 && !input.checked);
          input.checked = sel[g.key].indexOf(input.value) >= 0;
        });
      });
    }

    groupsEl.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.matches('input[type=checkbox]')) return;
      var key = input.closest('.sfw-ht__group').dataset.key;
      var list = sel[key];
      var at = list.indexOf(input.value);
      if (input.checked && at < 0) list.push(input.value);
      if (!input.checked && at >= 0) list.splice(at, 1);
      render();
    });
    groupsEl.addEventListener('click', function (e) {
      var head = e.target.closest('.sfw-ht__group-head');
      if (head) {
        var open = head.getAttribute('aria-expanded') !== 'true';
        head.setAttribute('aria-expanded', open);
        head.nextElementSibling.classList.toggle('is-open', open);
      }
      var more = e.target.closest('.sfw-ht__more');
      if (more) {
        var g = more.closest('.sfw-ht__group');
        var expanded = g.classList.toggle('show-all');
        more.innerHTML = '<span aria-hidden="true">' + (expanded ? '−' : '+') + '</span> ' + (expanded ? 'Ver menos' : 'Ver más');
      }
    });
    clears.forEach(function (b) {
      b.addEventListener('click', function () {
        GROUPS.forEach(function (g) { sel[g.key] = []; });
        render();
      });
    });
    if (toggle && side) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', open);
        side.classList.toggle('is-open', open);
      });
    }
    // ---------- catalogue page: gama tabs switch in place (no page load) ----------
    var tabs = [].slice.call(document.querySelectorAll('[data-sfw-tab]'));
    var head = document.querySelector('[data-sfw-colhead]');
    if (tabs.length && head && sel.gama) {
      var titleEl = head.querySelector('[data-sfw-coltitle]');
      var leadEl = head.querySelector('[data-sfw-collead]');
      var countEl2 = head.querySelector('[data-sfw-colcount]');
      var path = function (href) { try { return new URL(href, location.href).pathname; } catch (e) { return href; } };
      var paint = function (tab) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-on', on);
          if (on) t.setAttribute('aria-current', 'page'); else t.removeAttribute('aria-current');
        });
        if (!tab) return;
        var n = parseInt(tab.dataset.count, 10) || 0;
        if (titleEl) titleEl.textContent = tab.dataset.title;
        if (leadEl) { leadEl.textContent = tab.dataset.lead || ''; leadEl.hidden = !tab.dataset.lead; }
        if (countEl2) {
          countEl2.textContent = tab.dataset.gama
            ? n + ' ' + (n === 1 ? head.dataset.suffixOne : head.dataset.suffix)
            : n + (n === 1 ? ' referencia' : ' referencias');
        }
      };
      var tabFor = function () {
        if (sel.gama.length > 1) return null;
        var g = sel.gama[0] || '';
        return tabs.filter(function (t) { return t.dataset.gama === g; })[0] || null;
      };
      var sync = function (mode) {
        var tab = tabFor();
        paint(tab);
        if (!tab || mode === 'none') return;
        var href = tab.getAttribute('href');
        if (path(href) === location.pathname) return;
        if (mode === 'push') history.pushState({ sfwTab: href }, '', href);
        else history.replaceState({ sfwTab: href }, '', href);
      };
      var baseRender = render;
      render = function (mode) { baseRender(); sync(mode || 'replace'); };
      tabs.forEach(function (t) {
        t.addEventListener('click', function (e) {
          if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          e.preventDefault();
          sel.gama = t.dataset.gama ? [t.dataset.gama] : [];
          render('push');
        });
      });
      window.addEventListener('popstate', function () {
        var tab = tabs.filter(function (t) { return path(t.getAttribute('href')) === location.pathname; })[0];
        if (!tab) return;
        sel.gama = tab.dataset.gama ? [tab.dataset.gama] : [];
        render('none');
      });
    }

    render('none');
  }

  var boot = function () { [].forEach.call(document.querySelectorAll('[data-sfw-tienda]'), init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // theme editor: re-init when the section is added/re-rendered
  document.addEventListener('shopify:section:load', boot);
})();
